import React, { lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import OAuth2RedirectHandler from "../Pages/Account/OAuth2RedirectHandler";
import jwt_decode from "jwt-decode";

const Login = lazy(() => import("../Pages/Account/Login"));

const ResetPassword = lazy(() => import("../Pages/ResetPassword"));

const Admin = lazy(() => import("../Pages/Admin/Admin"));
const AdminDashboard = lazy(() => import("../Pages/Admin/AdminDashboard"));
const AdminUserRoleManagement = lazy(() => import("../Pages/Admin/AdminUserRoleManagement"));
const AdminStory = lazy(() => import("../Pages/Admin/AdminStory"));
const AdminReawards = lazy(() => import("../Pages/Admin/AdminReawards"));
const AdminAllCompanies = lazy(() => import("../Pages/Admin/AdminAllCompanies"));
const AdminCompanyAndBrandManagement = lazy(() => import("../Pages/Admin/AdminCompanyAndBrandManagement"));
const AdminProduct = lazy(() => import("../Pages/Admin/AdminProduct"));
const AdminCouponManagement = lazy(() => import("../Pages/Admin/AdminCouponManagement"));
const AdminOrderManagement = lazy(() => import("../Pages/Admin/AdminOrderManagement"));
const AdminNotification = lazy(() => import("../Pages/Admin/AdminNotification"));
// const AdminTenant = lazy(() => import("../Pages/Admin/AdminTenant"));
// const AdminCompany = lazy(()=> import("../Pages/Admin/AdminCompany"));
// const AdminEvents = lazy(() => import("../Pages/Admin/AdminEvents"));
const AdminSEOPages = lazy(() => import("../Pages/Admin/AdminSEOPages"));
// const AdminProspectiveSEOPages = lazy(() => import("../Pages/Admin/AdminProspectiveSEOPages"));
// const AdminMarketing = lazy(() => import("../Pages/Admin/AdminMarketing"));
const AdminBlogPage = lazy(() => import ("../Pages/Admin/AdminBlogPage"));
const Layout = lazy(() => import ("../layout/Layout"));

const routeLogic = (roles) => {
  // if (roles != null) {
  //   if (roles === "ADMIN") {
      return (
        <>
          <Route exact path="/admin/home" element={<Admin />}></Route>
          {/* <Route
            exact
            path="/admin/dashboard"
            element={<AdminDashboard />}
          ></Route>
          <Route
            exact
            path="/admin/user-role-management"
            element={<AdminUserRoleManagement />}
          ></Route>
          <Route
            exact
            path="/admin/tenant-list"
            element={<AdminTenant />}
          ></Route>
          <Route
            exact
            path="/admin/company-list"
            element={<AdminCompany />}
          ></Route>
          <Route
            exact
            path="/admin/blogs"
            element={<AdminBlogPage />}></Route>
           <Route
            exact
            path="/admin/seopages"
            element={<AdminSEOPages />}></Route>
           <Route
            exact
            path="/admin/prospectiveseo"
            element={<AdminProspectiveSEOPages />}></Route>
             <Route
            exact
            path="/admin/marketing"
            element={<AdminMarketing />}></Route>
             <Route exact path="/admin/events" element={<AdminEvents />}></Route> */}

            <Route path="admin" element={<Layout />}>
              <Route index path="dashboard" element={<AdminDashboard />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="user-role-management" element={<AdminUserRoleManagement />} />
              <Route path="story-rhymes-management" element={<AdminStory />} />
              <Route path="rewards-management" element={<AdminReawards />} />
              <Route path="company-brand-management" element={<AdminCompanyAndBrandManagement />} />
              <Route path="all-companies" element={<AdminAllCompanies />} />
              <Route path="product-management" element={<AdminProduct />} />
              <Route path="coupon-management" element={<AdminCouponManagement />} />
              <Route path="orders-management" element={<AdminOrderManagement />} />
              <Route path="notifications" element={<AdminNotification />} />
              {/* <Route path="tenant-list" element={<AdminTenant />} />
              <Route path="company-list" element={<AdminCompany />} /> */}
              <Route path="blogs" element={<AdminBlogPage />} />
              <Route path="seopages" element={<AdminSEOPages />} />
              {/* <Route path="prospectiveseo" element={<AdminProspectiveSEOPages />} /> */}
              {/* <Route path="marketing" element={<AdminMarketing />} /> */}
              {/* <Route path="events" element={<AdminEvents />} /> */}
            </Route>
        </>
      );
  //   }
  // }
};

function MainRouter(props) {
  // const dispatch = useDispatch();
  // const notification = useSelector((state) => state.notification);

  // useEffect();
  return (
    <Router>
      {/* <Notification
        type={notification.type}
        open={notification.Notification}
        message={notification.message}
        handleClose={() => {
          dispatch(offNotification());
        }}
      ></Notification> */}
      <React.Suspense fallback={<h1>Loading...</h1>}>
        <Routes>
          {/* {sessionStorage.getItem("token") != null &&
            (jwt_decode(sessionStorage.getItem("token"))?.role
              ? routeLogic(jwt_decode(sessionStorage.getItem("token"))?.role)
              : routeLogic(null))} */}
          {routeLogic("ADMIN")}
          <Route exact path="/login" element={<Login />}></Route>
          <Route
            exact
            path="/reset-password"
            element={<ResetPassword />}
          ></Route>
          {/* <Route exact path="/test" element={<Test />}></Route> */}
          <Route
            path="/oauth2/redirect"
            element={<OAuth2RedirectHandler />}
          ></Route>
          <Route exact path="*" element={<Login />} />
        </Routes>
      </React.Suspense>
    </Router>
  );
}

export default MainRouter;
